module.exports = __webpack_public_path__ + "img/step2.8a669316.png";